module.exports = __webpack_public_path__ + "static/media/address.1a6202ec.png";